/**
 * @generated SignedSource<<00ee0f9e76c76376e5aedb6c4b48c533>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type templateTabbedSectionContentfulRelayFragment$data = {
  readonly howToUseThisTemplateCollection: {
    readonly items: ReadonlyArray<{
      readonly " $fragmentSpreads": FragmentRefs<"templateGuideContentfulRelayFragment">;
    } | null | undefined>;
  } | null | undefined;
  readonly templateBenefitsCollection: {
    readonly items: ReadonlyArray<{
      readonly " $fragmentSpreads": FragmentRefs<"templateBenefitsContentfulRelayFragment">;
    } | null | undefined>;
  } | null | undefined;
  readonly templateOverviewCollection: {
    readonly items: ReadonlyArray<{
      readonly overviewDescription: {
        readonly json: any;
      } | null | undefined;
      readonly overviewTitle: string | null | undefined;
    } | null | undefined>;
  } | null | undefined;
  readonly templateProductRationaleCollection: {
    readonly items: ReadonlyArray<{
      readonly rationaleTitle: string | null | undefined;
      readonly templateProductRationaleDescription: {
        readonly json: any;
      } | null | undefined;
    } | null | undefined>;
  } | null | undefined;
  readonly " $fragmentType": "templateTabbedSectionContentfulRelayFragment";
};
export type templateTabbedSectionContentfulRelayFragment$key = {
  readonly " $data"?: templateTabbedSectionContentfulRelayFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"templateTabbedSectionContentfulRelayFragment">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "json",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "templateTabbedSectionContentfulRelayFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ProductTemplateTemplateOverviewCollection",
      "kind": "LinkedField",
      "name": "templateOverviewCollection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "TemplateOverview",
          "kind": "LinkedField",
          "name": "items",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "overviewTitle",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "TemplateOverviewOverviewDescription",
              "kind": "LinkedField",
              "name": "overviewDescription",
              "plural": false,
              "selections": (v0/*: any*/),
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ProductTemplateTemplateBenefitsCollection",
      "kind": "LinkedField",
      "name": "templateBenefitsCollection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "TemplateBenefitContainer",
          "kind": "LinkedField",
          "name": "items",
          "plural": true,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "templateBenefitsContentfulRelayFragment"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ProductTemplateHowToUseThisTemplateCollection",
      "kind": "LinkedField",
      "name": "howToUseThisTemplateCollection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "TemplateGuide",
          "kind": "LinkedField",
          "name": "items",
          "plural": true,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "templateGuideContentfulRelayFragment"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ProductTemplateTemplateProductRationaleCollection",
      "kind": "LinkedField",
      "name": "templateProductRationaleCollection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "TemplateProductRationale",
          "kind": "LinkedField",
          "name": "items",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "rationaleTitle",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "TemplateProductRationaleTemplateProductRationaleDescription",
              "kind": "LinkedField",
              "name": "templateProductRationaleDescription",
              "plural": false,
              "selections": (v0/*: any*/),
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ProductTemplate",
  "abstractKey": null
};
})();

(node as any).hash = "9e2878135e8f926d46ac10f3a93bce05";

export default node;
